import { render, staticRenderFns } from "./PaySettings.vue?vue&type=template&id=b8501d54"
import script from "./PaySettings.vue?vue&type=script&lang=js"
export * from "./PaySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports